import React from 'react';
import { useNavigate } from 'react-router-dom';
import FavoriteButton from './FavoriteButton';
import RatingDisplay from './RatingDisplay';
import { Property } from '../types/Property';

interface PropertyCardProps {
  property: Property;
}

const PropertyCard: React.FC<PropertyCardProps> = ({ property }) => {
  const navigate = useNavigate();

  const handlePropertyClick = () => {
    navigate(`/property/${property.id}`, { 
      state: { property }
    });
  };

  return (
    <div 
      className="group cursor-pointer transition-all duration-300 hover:scale-[1.02]"
      onClick={handlePropertyClick}
    >
      <div className="relative aspect-square overflow-hidden rounded-xl">
        <img 
          src={property.imageUrl} 
          alt={`${property.title} in ${property.location}`}
          className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <FavoriteButton 
          className="absolute top-3 right-3 z-10"
          onClick={(e) => {
            e.stopPropagation();
            // Favorite handling logic here
          }}
        />
      </div>
      
      <div className="mt-3">
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-base font-medium text-gray-900 line-clamp-1">
              {property.title}
            </h3>
            <p className="text-sm text-gray-600 mt-0.5">
              {property.location}
            </p>
            <div className="mt-1 flex items-center gap-1">
              <span className="text-sm font-medium">
                ${property.price}
              </span>
              <span className="text-sm text-gray-500">
                per night
              </span>
            </div>
          </div>
          <RatingDisplay 
            rating={property.rating} 
            className="flex-shrink-0"
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;